export enum StaticPurposes {
  Other = 'Other',
  Charity = 'Charity',
  Medical = 'Medical',
  Moving = 'Moving',
  Commute = 'Commute'
}

export enum IncomeSources {
  realEstate = 'Real Estate',
  photography = 'Photography',
  uber = 'Uber',
  lyft = 'Lyft',
  insurance = 'Insurance',
  fieldNation = 'Field Nation',
  taxPro = 'Tax Pro',
  homeServices = 'Home Services',
  doordash = 'Doordash',
  instacart = 'Instacart',
  creative = 'Creative',
  taskrabbit = 'Taskrabbit',
  airbnb = 'Airbnb',
  postmates = 'Postmates',
  wonolo = 'Wonolo',
  favor = 'Favor',
  shipt = 'Shipt',
  foodServices = 'Food Services',
  coaching = 'Coaching',
  tutoring = 'Tutoring',
  trucking = 'Trucking',
  religiousServices = 'Religious Services',
  physician = 'Physician',
  consultant = 'Consultant',
  legal = 'Legal',
  other = 'Other',
  amazonflex = 'Amazon Flex',
  grubhub = 'Grubhub',
  wag = 'Wag',
  gopuff = 'GoPuff',
  thumbtack = 'Thumbtack'
}

export enum VariableScheduleFrequencyOption {
  monthly = 'monthly',
  first_and_sixteenth = 'first_and_sixteenth',
  weekly = 'weekly',
  biweekly = 'biweekly',
  biweekly_alternate = 'biweekly_alternate',
  none = 'none'
}

export enum FixedScheduleFrequencyOption {
  monthly = 'monthly',
  first_and_sixteenth = 'first_and_sixteenth',
  weekly = 'weekly',
  biweekly = 'biweekly',
  biweekly_alternate = 'biweekly_alternate'
}

export enum AutoCreateReportOptions {
  weekly = 'weekly',
  monthly = 'monthly',
  none = 'none',
  biweekly = 'biweekly',
  biweekly_alternate = 'biweekly_alternate',
  first_and_sixteenth = 'first_and_sixteenth'
}

export enum PaymentReceivedDaysRanges {
  '5-7' = '5-7',
  '7-10' = '7-10',
  next_paycheck = 'next_paycheck'
}

export enum Weekday {
  monday = 'monday',
  tuesday = 'tuesday',
  wednesday = 'wednesday',
  thursday = 'thursday',
  friday = 'friday',
  saturday = 'saturday',
  sunday = 'sunday'
}
